import React, { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

export const ReadOnlyHandler = ({ readOnly }) => {
  const [editor] = useLexicalComposerContext();
  
  useEffect(() => {
    editor.setEditable(!readOnly);
  }, [readOnly, editor]);
  
  return null;
};